(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("tab", [], factory);
	else if(typeof exports === 'object')
		exports["tab"] = factory();
	else
		root["tab"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 